(function () {
  // Read config injected by optin-free-gift.liquid
  var dataEl = document.getElementById("gwp-offer-data");
  if (!dataEl) return;

  var config;
  try { config = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var text = config.text || {};
  var rules = (config.rules || []).filter(function (r) { return r.enabled !== false; });
  if (!rules.length) return;

  // Our own cart calls use the unpatched fetch so they don't re-trigger the
  // reconciler through the interceptor at the bottom of this file.
  var _fetch = window.fetch;

  // ── cart helpers ──────────────────────────────────────────────────────────

  function getCart() {
    return _fetch.call(window, "/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return _fetch.call(window, url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error("gwp: " + url + " " + r.status);
      return r;
    });
  }

  function addItem(variantId, qty, props) {
    return post("/cart/add.js", { items: [{ id: variantId, quantity: qty, properties: props }] });
  }

  function setQty(lineKey, qty) {
    return post("/cart/change.js", { id: lineKey, quantity: qty });
  }

  // ── rule evaluation ───────────────────────────────────────────────────────

  // ── landing-page discount suppression ─────────────────────────────────────
  // The pick-a-block page arms this flag the moment it reveals a code, and
  // stamps it with the code's own expiry.
  //
  // While it is live, every rule reports its condition as UNMET, so the offer
  // is hidden and a gift already in the cart is removed. The gift is a $0 line
  // only because of the "Free Busy Board" BXGY, and that BXGY cannot combine
  // with an order discount. Leave the board in the cart alongside a block code
  // and it stops being free — the customer gets charged for it.

  var BLOCK_KEY = "sw_block_active";

  function blockCodeLive() {
    try {
      var r = JSON.parse(localStorage.getItem(BLOCK_KEY) || "null");
      if (!r || !r.until) return false;
      if (Date.now() >= r.until) {         // expired — tidy up and carry on
        localStorage.removeItem(BLOCK_KEY);
        return false;
      }
      return true;
    } catch (e) {
      return false;                        // private mode, quota, bad JSON
    }
  }

  function conditionMet(rule, cart) {
    if (blockCodeLive()) return false;

    switch (rule.conditionType) {
      case "subtotal_min":
        // conditionValue is in dollars — cart uses cents
        return cart.items_subtotal_price >= Math.round(rule.conditionValue * 100);

      case "product_in_cart":
        return cart.items.some(function (item) {
          return !isGift(item) && String(item.product_id) === String(rule.conditionValue);
        });

      case "any_product_in_cart":
        // conditionValue is an array of variant IDs — offer shows if ANY are in the cart
        var ids = [].concat(rule.conditionValue).map(String);
        return cart.items.some(function (item) {
          return !isGift(item) && ids.indexOf(String(item.variant_id)) !== -1;
        });

      case "collection_in_cart":
        // conditionValue is an array of product IDs rendered by Liquid from a collection
        var collectionIds = [].concat(rule.conditionValue).map(String);
        return cart.items.some(function (item) {
          return !isGift(item) && collectionIds.indexOf(String(item.product_id)) !== -1;
        });

      default:
        return false;
    }
  }

  function isGift(item) {
    return !!((item.properties || {})["_gwp"]);
  }

  function giftLineForRule(cart, ruleId) {
    for (var i = 0; i < cart.items.length; i++) {
      if ((cart.items[i].properties || {})["_gwp"] === String(ruleId)) {
        return cart.items[i];
      }
    }
    return null;
  }

  function ruleById(ruleId) {
    for (var i = 0; i < rules.length; i++) {
      if (String(rules[i].id) === String(ruleId)) return rules[i];
    }
    return null;
  }

  // ── view state ────────────────────────────────────────────────────────────
  // Everything paint() needs. Rebuilt from the cart by reconcile(); the theme
  // wipes our markup whenever it re-renders the cart, so paint() has to be
  // able to put it back from this at any time.

  var view = [];        // [{ rule }] — one entry per offer unlocked and not yet taken
  var giftLines = [];   // [{ line, handle }] — 1-based cart lines that are gifts
  var pending = {};     // ruleId → true while an add request is in flight
  var failed = {};      // ruleId → true if the last add failed
  var notice = "";      // shown after a gift is removed because the cart stopped qualifying
  var itemCount = 0;    // shown next to the cart heading under the offer panel

  function buildView(cart) {
    view = [];
    giftLines = [];
    itemCount = cart.item_count || 0;
    rules.forEach(function (rule) {
      if (!conditionMet(rule, cart)) return;
      // Once the gift is in the cart the offer steps aside — the gift's own
      // cart line (with the theme's remove button) is all the customer needs.
      // Removing that line brings the offer back.
      if (giftLineForRule(cart, rule.id)) return;
      if (rule.gift && rule.gift.available === false) return;   // sold out
      view.push({ rule: rule });
    });
    cart.items.forEach(function (item, i) {
      if (isGift(item)) giftLines.push({ line: i + 1, handle: item.handle });
    });
  }

  // ── rendering ─────────────────────────────────────────────────────────────

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function offerHtml(offer) {
    var rid = String(offer.rule.id);
    var gift = offer.rule.gift || {};
    var label = pending[rid] ? text.addingLabel : text.addLabel;

    return (
      '<div class="gwp-offer">' +
        (gift.image ? '<img class="gwp-offer__img" src="' + esc(gift.image) + '" alt="" width="64" height="64" loading="lazy">' : "") +
        '<div class="gwp-offer__info">' +
          '<div class="gwp-offer__title">' + esc(gift.title) + "</div>" +
          '<div class="gwp-offer__prices">' +
            (gift.price ? "<s>" + esc(gift.price) + "</s>" : "") +
            "<em>" + esc(text.freeLabel) + "</em>" +
          "</div>" +
        "</div>" +
        '<button type="button" class="gwp-offer__btn" data-gwp-add="' + esc(rid) + '"' +
          (pending[rid] ? " disabled" : "") + ">" + esc(label) + "</button>" +
      "</div>" +
      (failed[rid] ? '<p class="gwp-offers__error" role="alert">' + esc(text.errorText) + "</p>" : "")
    );
  }

  // The offers sit in their own panel, clearly apart from the cart lines.
  //   panelTitle — print the "Offers" label inside the panel
  //   cartTitle  — add a cart heading under the panel, so the customer can see
  //                where the offers end and their actual cart begins
  function buildHtml(target) {
    var html = "";
    if (view.length) {
      html += '<div class="gwp-offers__panel">';
      if (target.panelTitle && text.offersTitle) html += '<p class="gwp-offers__title">' + esc(text.offersTitle) + "</p>";
      html += '<p class="gwp-offers__status">' + esc(text.heading) + "</p>";
      html += view.map(offerHtml).join("");
      if (text.finePrint) html += '<p class="gwp-offers__fineprint">' + esc(text.finePrint) + "</p>";
      html += "</div>";
    }
    if (notice) html += '<p class="gwp-offers__notice" role="status">' + esc(notice) + "</p>";
    if (view.length && target.cartTitle) {
      html += '<p class="gwp-offers__cart-title h4">' + esc(target.cartTitle) + " <span>(" + itemCount + ")</span></p>";
    }
    return html;
  }

  // While an offer is showing, the drawer's own heading ("Cart") reads
  // "Offers" instead, and the cart heading moves under the offer panel — so
  // there is one heading per section rather than two cart headings in a row.
  // Returns the theme's original heading text, or null if there is no heading
  // to swap. The theme re-renders the heading on every cart change, which
  // resets it; paint() calls this again each time.
  function swapDrawerHeading(showOffers) {
    var el = document.querySelector("#Cart-Drawer .side-panel-header .h4");
    if (!el || !text.offersTitle) return null;
    var original = el.getAttribute("data-gwp-original");
    if (showOffers) {
      if (original === null) {
        original = el.textContent;
        el.setAttribute("data-gwp-original", original);
      }
      if (el.textContent !== text.offersTitle) el.textContent = text.offersTitle;
      el.classList.add("gwp-heading-offers");
      return original;
    }
    if (original !== null) {
      el.textContent = original;
      el.removeAttribute("data-gwp-original");
      el.classList.remove("gwp-heading-offers");
    }
    return null;
  }

  // Where the offer block goes: top of the cart drawer, and top of the
  // items column on the /cart page (which already has its own cart heading).
  function hosts() {
    var list = [];
    var drawer = document.querySelector("#Cart-Drawer .side-panel-content");
    if (drawer) {
      var heading = swapDrawerHeading(view.length > 0);
      list.push({
        el: drawer,
        panelTitle: heading === null,
        cartTitle: heading === null ? "" : (text.cartTitle || heading.trim()),
      });
    }
    var form = document.querySelector("#Cart #cart-form");
    if (form && form.parentNode) list.push({ el: form.parentNode, panelTitle: true, cartTitle: "" });
    return list;
  }

  // Gift lines get a class so the stylesheet can hide their quantity selector
  function markGiftLines() {
    var handles = {};
    giftLines.forEach(function (g) {
      handles["CartDrawerItem-" + g.line] = g.handle;
      handles["CartItem-" + g.line] = g.handle;
    });
    var els = document.querySelectorAll('[id^="CartDrawerItem-"], [id^="CartItem-"]');
    for (var i = 0; i < els.length; i++) {
      var handle = handles[els[i].id];
      // The DOM can be one render behind the cart, so confirm the line really is the gift
      var isGiftLine = !!handle && !!els[i].querySelector('a[href*="/products/' + handle + '"]');
      els[i].classList.toggle("gwp-gift-line", isGiftLine);
    }
  }

  function paint() {
    hosts().forEach(function (target) {
      var host = target.el;
      var html = buildHtml(target);
      var box = null;
      for (var i = 0; i < host.children.length; i++) {
        if (host.children[i].classList.contains("gwp-offers")) { box = host.children[i]; break; }
      }
      if (!html) {
        if (box) box.remove();
        return;
      }
      if (!box) {
        box = document.createElement("div");
        box.className = "gwp-offers";
        host.insertBefore(box, host.firstChild);
      }
      // Only touch the DOM when something changed — paint() runs from a MutationObserver
      if (box._gwpHtml !== html) {
        box.innerHTML = html;
        box._gwpHtml = html;
      }
    });
    markGiftLines();
  }

  function refreshTheme() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated"));
    if (window.PUB_SUB_EVENTS && window.publish) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {}); } catch (e) {}
    }
  }

  // ── reconciler ────────────────────────────────────────────────────────────
  // Never adds a gift — that only happens when the customer clicks the button.
  // It removes a gift whose condition is no longer met, holds the gift at its
  // set quantity, and rebuilds the offer block.

  var busy = false;
  var queued = false;
  var queuedRefresh = false;

  function reconcile(forceRefresh) {
    if (busy) {
      queued = true;
      queuedRefresh = queuedRefresh || !!forceRefresh;
      return;
    }
    busy = true;
    queued = false;

    getCart().then(function (cart) {
      var chain = Promise.resolve();
      var madeChanges = false;
      var giftRemoved = false;

      rules.forEach(function (rule) {
        var existing = giftLineForRule(cart, rule.id);
        if (!existing) return;

        if (!conditionMet(rule, cart)) {
          madeChanges = true;
          giftRemoved = true;
          chain = chain.then(function () {
            return setQty(existing.key, 0).catch(function () {});
          });
        } else if (existing.quantity !== rule.giftQuantity) {
          madeChanges = true;
          chain = chain.then(function () {
            return setQty(existing.key, rule.giftQuantity).catch(function () {});
          });
        }
      });

      // Remove orphaned gifts (rule deleted or disabled but item still in cart)
      cart.items.forEach(function (item) {
        if (!isGift(item) || ruleById(item.properties["_gwp"])) return;
        madeChanges = true;
        chain = chain.then(function () {
          return setQty(item.key, 0).catch(function () {});
        });
      });

      notice = giftRemoved ? (text.removedNotice || "") : "";

      if (!madeChanges) return { cart: cart, changed: false };
      return chain.then(getCart).then(function (fresh) {
        return { cart: fresh, changed: true };
      });
    })
    .then(function (result) {
      buildView(result.cart);
      paint();
      // Only ask the theme to re-render if the cart actually changed
      if (result.changed || forceRefresh) refreshTheme();
    })
    .catch(function () {})
    .then(function () {
      busy = false;
      if (queued) {
        var refresh = queuedRefresh;
        queuedRefresh = false;
        setTimeout(function () { reconcile(refresh); }, 0);
      }
    });
  }

  // ── add button ────────────────────────────────────────────────────────────

  document.addEventListener("click", function (event) {
    var btn = event.target.closest ? event.target.closest("[data-gwp-add]") : null;
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var rid = btn.getAttribute("data-gwp-add");
    var rule = ruleById(rid);
    if (!rule || pending[rid]) return;

    pending[rid] = true;
    delete failed[rid];
    paint();

    addItem(rule.giftVariantId, rule.giftQuantity, { "_gwp": String(rule.id) })
      .catch(function () { failed[rid] = true; })
      .then(function () {
        delete pending[rid];
        reconcile(true);
      });
  });

  // ── intercept cart mutations ──────────────────────────────────────────────

  var debounce;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(reconcile, 300);
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ""));
  }

  // Patch fetch
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input || {}).url;
    var p = _fetch.apply(window, arguments);
    if (isCartMutation(url)) p.then(schedule, schedule);
    return p;
  };

  // Patch XHR
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this._gwpWatch = isCartMutation(url);
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._gwpWatch) this.addEventListener("loadend", schedule);
    return _send.apply(this, arguments);
  };

  // ── start ─────────────────────────────────────────────────────────────────

  function start() {
    // The theme replaces the cart drawer / cart page markup on every cart
    // change, which wipes the offer block. Put it straight back.
    var observer = new MutationObserver(paint);
    ["Cart-Drawer", "Cart"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
    reconcile();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
